import React, { useState, useEffect } from 'react'

const InstagramComments = () => {
  const [comments, setComments] = useState([])
  const [loading, setLoading] = useState(true)

  // Real comments data with profile pictures
  const sampleComments = [
    {
      id: 1,
      username: "katelinchesna",
      profilePic: "/profile1.jpg",
      text: "I cannot recommend this retreat enough!!! Victoria is an incredible facilitator and guide! This retreat showed me parts of myself. I had not fully been loving. It was a return to those parts of myself, and I have been noticeably different since",
    },
    {
      id: 2,
      username: "sommer.awesome",
      profilePic: "/profile2.jpg",
      text: "✨Victoria's retreat cracked me open in the best way—it wasn't just about healing, it was about finding freedom. The space she holds is magic, and the growth continues long after the retreat ends.✨",
    },
    {
      id: 3,
      username: "koshkinaa",
      profilePic: "/profile3.jpg",
      text: "Loved being part of this before — it was such a profound and unforgettable experience for me. I'm so glad you're offering this again and giving others the chance to go through it too. What you create is truly magical, and I'm so proud of you ✨",
    },
    {
      id: 4,
      username: "victoriyaom",
      profilePic: "/profile4.jpg",
      text: "Thank you so much for sharing your wisdom! The healing session with you was incredibly transformative and profound. I'm really looking forward to attending this one!",
    },
    {
      id: 5,
      username: "vilmakutaviciute",
      profilePic: "/profile5.jpg",
      text: "This is the game changer. The key to the new self, new reality — as it is. Buckle up, if you're ready ( are you?)",
    },
    {
      id: 6,
      username: "chrisdrummond99",
      profilePic: "/profile6.jpg",
      text: "I went to this retreat last month after facing a trauma that showed me a repeated pattern in my life . It helped me reset back to my true identity—and since then it's as if the universe has opened up with amazing opportunities, new career paths, and life-changing events unfolding right now.",
    }
  ]

  useEffect(() => {
    // Simulate loading comments
    setTimeout(() => {
      setComments(sampleComments)
      setLoading(false)
    }, 1000)
  }, [])

  if (loading) {
    return (
      <section className="instagram-comments">
        <div className="container">
          <h2>Community Voices</h2>
          <div className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
            <p>Loading community feedback...</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="instagram-comments">
      <div className="container">
        <div className="comments-header">
          <h2>Community Voices</h2>
          {/* <p>Real testimonials from retreat participants</p> */}
        </div>
        
        <div className="comments-grid">
          {comments.map((comment) => (
            <div key={comment.id} className="comment-card">
              <div className="comment-header">
                <img 
                  src={comment.profilePic} 
                  alt={comment.username}
                  className="comment-avatar"
                />
                <div className="comment-user-info">
                  <span className="comment-username">@{comment.username}</span>
                  {/* <span className="comment-timestamp">{comment.timestamp}</span> */}
                </div>
              </div>
              
              <div className="comment-content">
                <p>{comment.text}</p>
              </div>
              
              {/* <div className="comment-actions">
                <button className="comment-like">
                  <i className="fas fa-heart"></i>
                  <span>{comment.likes}</span>
                </button>
              </div> */}
            </div>
          ))}
        </div>

        <div className="comments-cta">
          {/* <p>Want to see more community stories?</p> */}
          <a 
            href="https://www.instagram.com/p/DPMX28cCRBp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-secondary"
          >
            <i className="fab fa-instagram"></i>
            View on Instagram
          </a>
        </div>
      </div>
    </section>
  )
}

export default InstagramComments
